module.exports = __webpack_public_path__ + "img/23.085da75d.jpg";